export const feedPatchKeys = ["patchedKg", "patchedKgPerHead", "patchTimestamp", "patchUserId", "patchUserName", "patchUserEmail"];
export const feedPatchFields = feedPatchKeys.join("\n");

export async function detectFeedPatchFields(dispatch: (request: any) => Promise<any>, locationGuid: string): Promise<boolean> {
  try {
    await dispatch({
      gql: `query FeedPatchFields($guid: String!) {
        CribScores(guid: $guid) { cribScores { ${feedPatchFields} } }
      }`,
      variables: { guid: locationGuid },
    });
    return true;
  } catch (err) {
    // A schema validation failure guarantees that the query did not execute.
    const message = err instanceof Error ? err.message : String(err);
    const unsupportedField = feedPatchKeys.some((field) => message.includes(`Cannot query field "${field}" on type "CribReadingItem"`));
    if (unsupportedField) return false;
    throw err;
  }
}

export function formatPatchedCall(call: number, patchedKgPerHead?: number | null): string {
  const amount = Number(call).toFixed(2);
  return patchedKgPerHead == null ? amount : `${amount} (${Number(patchedKgPerHead).toFixed(1)})`;
}

export function patchUser(item: any): string {
  return item.patchUserName || item.patchUserEmail || item.patchUserId || "Unknown";
}
